import { Symbol, symbolSizes } from "@hubrise/react-components"
import * as React from "react"

import { Chevron, Content, Header } from "./Styles"

interface FoldableSectionProps {
  title: string
  expanded: boolean
  onToggle: () => void
  children: React.ReactNode
}

const FoldableSection = ({ title, expanded, onToggle, children }: FoldableSectionProps): JSX.Element => (
  <div>
    <Header onClick={onToggle}>
      <Chevron $expanded={expanded}>
        <Symbol code="chevron_right" size={symbolSizes._24} />
      </Chevron>
      {title}
    </Header>

    {expanded && <Content>{children}</Content>}
  </div>
)

export default FoldableSection
